<template>
	<div class="box-collection">
    <Notification ref="notif" :closed="true" corner="bottom-right" style="color:#061529;"/>
		<div class="header">
			<div class="container">
				<div class="box-header">
					<h2 class="page-title"><em>{{ colecao.nome }}</em></h2>
					<div class="desc">{{ colecao.descricao }}</div>
				</div>
			</div>
		</div>
		<div class="box-top">
			<div class="box-infos">
				<span class="update">Atualizado em: {{ colecao.dtUpdate }}</span>
				<span class="name"><i class="fas fa-folder-open"></i>{{ colecao.nome }}<i class="fas fa-chevron-down" ></i></span>
				<span class="info">Você pode alterar a ordem dos objetos arrastando-os para a posição desejada.</span>
			</div>
			<div class="btns">
				<button class="rename" v-if="colecao.status === 'Rascunho' && $auth.user().id === colecao.autorId" @click="boxRenameCollectionToggle(colecao)"><i class="fas fa-edit"></i> <span class="text"> editar </span></button>
				<button class="clonar" @click="clonar"><i class="fas fa-clone"></i><span class="text">clonar </span></button>
				<button class="add" v-if="colecao.status === 'Rascunho' && $auth.user().id === colecao.autorId" @click="boxCreateCollectionToggle(colecao.id)"><i class="fas fa-folder-plus"></i><span class="text"> adicionar </span></button>
				<button class="delete" v-if="colecao.status === 'Rascunho' && $auth.user().id === colecao.autorId" @click="boxRemoveCollectionToggle(colecao.id)"><i class="fas fa-trash-alt"></i><span class="text"> excluir </span></button>
				<button class="send" v-if="colecao.status === 'Rascunho' && $auth.user().id === colecao.autorId" @click="enviaProd(colecao.id)">ENVIAR</button>
				<button class="voltar"  @click="$router.go(-1)"><i class="far fa-arrow-alt-circle-left"></i><span class="text">voltar </span></button>
			</div>
		</div>
		<draggable v-model="colecao.objetos" group="colecao" @start="drag=true" @end="reorderCollection(colecao)" :disabled="colecao.status !== 'Rascunho' || $auth.user().id !== colecao.autorId">
			<div class="object-list" v-for="(obj, index) in colecao.objetos" :key="index + 1">
				<span class="number"> #{{index + 1}} <div class="ball"></div></span>
				<div class="box-object">
					<span>
						<i class="fas fa-arrows-alt"></i>
					</span>
					<span class="name-object">{{obj.titulo}}</span>
					<span class="type">Tipo: {{ obj.tipoNome }}</span>
					<div class="bts">
						<div class="comment" v-if="colecao.status === 'Rascunho' && $auth.user().id === colecao.autorId" @click="commentObjectCollection(obj)" ><span class="material-icons">add_comment</span><span class="txt">comentar</span></div>
						<div class="view" @click="$router.push('/objeto/' + obj.objetoId)"><i class="fas fa-eye"></i><span class="txt-view"></span><span class="txt">visualizar</span></div>
						<div class="delete" v-if="colecao.status === 'Rascunho' && $auth.user().id === colecao.autorId"  @click="boxRemoveObjectCollectionToggle(colecao.id, obj.objetoId)"><i class="fas fa-trash-alt"></i><span class="txt">excluir</span></div>
					</div>
				</div>
			</div>
		</draggable>
		<SubColecoes v-for="(sub, index) in colecao.subColecoes" :key="(index + 1)" :colecao="sub" :colecoes="sub.subColecoes"></SubColecoes>
		<Comentario :colecao="colecao" :disabled="$auth.user().id === colecao.autorId && colecao.status === 'Rascunho'"></Comentario>
		<Sucesso v-if="exibe" :titulo="titulo" :subTitulo="subtitulo" :subTituloNegrito="subTituloNegrito" :protocolo="protocolo"></Sucesso>
		<EditarPasta @boxMessage="boxMsg" @boxDescartar="boxRenameCollectionToggle" v-if="boxEditCollection.show" :id="boxEditCollection.id" :nome="boxEditCollection.nome" :descricao="boxEditCollection.descricao" :idColecao="boxEditCollection.colecaoId" :add="boxEditCollection.add"></EditarPasta>
		<ModalRemove @boxDescartar="boxRemoveCollectionToggle" @boxDelete="removeCollection" :id="boxRemoveCollection.id" v-if="boxRemoveCollection.show" titulo="Deseja remover esta coleção ?" subTitulo="Não é possível restaurar essa ação."/>
		<ModalRemove @boxDescartar="boxRemoveObjectCollectionToggle" @boxDelete="removeObjectCollection" :id="boxRemoveObjectCollection.id" :item="boxRemoveObjectCollection.item" v-if="boxRemoveObjectCollection.show" titulo="Deseja remover este Objeto ?" subTitulo="Não é possível restaurar essa ação."/>
		<ModalComentario @boxCloseComment="boxCommentObjectCollectionToggle" :objetoColecao="boxCommentCollection.objetoColecao" v-if="boxCommentCollection.show" ></ModalComentario>
		<!-- Modal -->
		<ModalEdit v-show="isModalVisible">
			<template v-slot:body>
				<form @submit.prevent>
					<div class="row full">
						<div>
							<label>Deseja clonar a coleção:  <span>{{ colecao.nome }}?</span></label>
						</div>
					</div>
					<div class="actions">
						<button @click="confirm(colecao.id)">CONFIRMAR</button>
						<button @click="cancelar">CANCELAR</button>
					</div>
				</form>
			</template>
		</ModalEdit>
		<!-- Final modal -->
	</div>
</template>

<script>
import EditarPasta from './inc/EditarPasta'
import SubColecoes from './inc/SubColecoes'
import { colecoes } from '@/services/colecoes'
import Comentario from '@/components/views/colecoes/inc/Comentario'
import Sucesso from '@/components/views/colecoes/inc/Sucesso'
import draggable from 'vuedraggable'
import ModalRemove from '@/components/shared/ModalRemove'
import ModalComentario from '@/components/shared/ModalComentario'
import ModalEdit from '@/components/shared/ModalEdit'
import EventBus from '@/components/event-bus'

export default {
	name: 'VisualizarColecao',
	components: { SubColecoes, Comentario, Sucesso, draggable, EditarPasta, ModalRemove, ModalComentario, ModalEdit },
	data () {
		return {
			obj: '',
			colecao: {},
			id: '',
			titulo: '',
			protocolo: '',
			subtitulo: '',
			subTituloNegrito: '',
			exibe: false,
			listProducao: [],
			boxEditCollection: { show: false },
			boxCommentCollection: { show: false },
			boxRemoveCollection: { show: false },
			boxRemoveObjectCollection: { show: false },
			isModalVisible: false,
			data: {},
			status: '',
			message: '',
			msg: ''
		}
	},
	created () {
		EventBus.$emit('closeLoader', true)
		this.init()
		EventBus.$on('removeCollection', this.boxRemoveCollectionToggle)
		EventBus.$on('createCollection', this.boxCreateCollectionToggle)
		EventBus.$on('renameCollection', this.boxRenameCollectionToggle)
		EventBus.$on('reorderCollection', this.reorderCollection)
		EventBus.$on('removeObjectCollection', this.boxRemoveObjectCollectionToggle)
		EventBus.$on('commentObjectCollection', this.boxCommentObjectCollectionToggle)
	},
	methods: {
		async init () {
			this.id = this.$route.query.id
			this.message = this.$route.params.message

			await colecoes.obterArvoreObjetos(this.id)
				.then(res => {
					let objFaltandoPreRequisito = ''
					res.data.objetos.filter(obj => obj.preRequisito && !res.data.objetos.some(el => el.objetoId === obj.preRequisito)).forEach((resultado, index) => {
						if (index > 0) {
							objFaltandoPreRequisito += ', ' + resultado.titulo
						} else {
							objFaltandoPreRequisito = resultado.titulo
						}
					})

					if (objFaltandoPreRequisito.length !== 0) {
						window.notificationEM.open('', `O(s) seguinte(s) objeto(s) tem pré requisito não atendido: ${objFaltandoPreRequisito}!`, '')
					}

					this.colecao = res.data
				})
				.catch(err => console.log(err))

			EventBus.$emit('closeLoader', false)

			if (this.message) {
				window.notificationEM.open('', this.message, 'success')
				this.$route.params.message = ''
			}
		},
		boxMsg (mensagem, tipo) {
			window.notificationEM.open('', mensagem, tipo)
		},
		async enviaProd (id) {
			await colecoes.enviarProd(id)
				.then(res => {
					this.titulo = 'Coleção enviada com sucesso !'
					this.protocolo = this.listProducao.numero
					this.subtitulo = 'Você pode acompanhar o status das suas coleções acessando o seu'
					this.subTituloNegrito = 'Perfil.'
					this.verSucesso()
					setTimeout(this.verSucesso, 3000)
					this.init()
				})
				.catch(err => console.log(err))
		},
		async removeObjectCollection (colId, objId) {
			const colecao = await colecoes.deleteObjetoColecao(colId, objId)
			if (colecao.status === 200) {
				this.init()
				this.boxRemoveObjectCollection.show = false
				window.notificationEM.open('', 'Objeto removido da Coleção com Sucesso!', 'success')
			} else {
				window.notificationEM.open('', `Objeto não foi removido da Coleção! ${colecao.status}`, 'error')
			}
		},
		async reorderCollection (colecao) {
			const objetos = colecao.objetos.map((o, i) => {
				return {
					objetoId: o.objetoId,
					ordem: i + 1
				}
			})
			const colecaoOrdenada = await colecoes.reordenarObjetosColecao(colecao.id, objetos)
			if (colecaoOrdenada.status === 200) {
				window.notificationEM.open('', 'Posição alterada com sucesso', 'success')
			} else {
				window.notificationEM.open('Erro !', `Posição não pode ser alterada - Erro: ${colecaoOrdenada.status}`, 'error')
			}
			return false
		},

		async removeCollection (id) {
			const colecao = await colecoes.delete(id)
			if (colecao.status === 200) {
				this.boxRemoveCollection.show = false
				this.$router.push({ name: 'minhasColecoes', params: { message: 'Coleção removida com sucesso !' } })
			} else {
				this.boxRemoveCollection.show = false
				window.notificationEM.open('Erro !', `Coleção não foi removida! - Error: ${colecao.status}`, 'error')
			}
		},

		verSucesso () {
			this.exibe = !this.exibe
			this.init()
		},
		commentObjectCollection (objetoColecao) {
			EventBus.$emit('commentObjectCollection', objetoColecao)
		},
		boxCommentObjectCollectionToggle (objetoColecao) {
			this.boxCommentCollection.objetoColecao	= objetoColecao
			this.boxCommentCollection.show = !this.boxCommentCollection.show
		},

		boxCreateCollectionToggle (colecaoId = null) {
			this.boxEditCollection.add	= true
			this.boxEditCollection.id	= null
			this.boxEditCollection.nome	= null
			this.boxEditCollection.colecaoId	= colecaoId
			this.boxEditCollection.show = !this.boxEditCollection.show
			this.init()
		},

		boxRemoveCollectionToggle (id) {
			this.boxRemoveCollection.show = !this.boxRemoveCollection.show
			this.boxRemoveCollection.id = id
		},

		boxRenameCollectionToggle (colecao) {
			this.boxEditCollection.add	= false
			this.boxEditCollection.id	= colecao.id
			this.boxEditCollection.nome	= colecao.nome
			this.boxEditCollection.descricao	= colecao.descricao
			this.boxEditCollection.colecaoId	= colecao.colecaoId
			this.boxEditCollection.show = !this.boxEditCollection.show
			this.init()
		},

		boxRemoveObjectCollectionToggle (id, item) {
			this.boxRemoveObjectCollection.show = !this.boxRemoveObjectCollection.show
			this.boxRemoveObjectCollection.id = id
			this.boxRemoveObjectCollection.item = item
		},
		clonar () {
			this.isModalVisible = true
		},
		cancelar () {
			this.isModalVisible = false
		},
		async confirm (id) {
			await colecoes.clonar(id)
				.then(res => {
					this.data = res.data
					this.status = res.status
				})
				.catch(err => console.log(err))

			if (this.status === 200) {
				EventBus.$emit('closeLoader', true)
				this.$router.push({ name: 'visualizarColecao', params: { message: 'Clonado com Sucesso !' }, query: { id: this.data.id } })
			} else {
				window.notificationEM.open('', `Erro ao clonar ${this.status}`, 'error')
			}
			this.isModalVisible = false
		}
	},
	watch: {
		$route: 'init'
	}
}
</script>

<style lang="scss" scoped>
	.box-collection {
		.header {
			background-color: #06162B;
			margin-bottom: 60px;
			position: relative;
			left: calc(((100vw - 1346px) / 2) * -1);
			width: 100vw;

			.box-header {
				border-bottom: 3px solid;
				border-color:#8B94A7;
				padding:80px 0px 30px;

				.page-title {
					color: #59708f;
					text-align: left;
					font-size: 3.5em;
					font-weight: 700;
					font-style: italic;
					margin: 40px 0px;
					text-transform: uppercase;
				}

				.desc {
					color: #ffffff;
					margin-bottom: 60px;
					text-align: justify;
				}
			}
		}
		.box-top {
			display:flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 40px;

			.box-infos {
				display: flex;
				flex-direction: column;

				.update {
					font-size: 14px;
					color: #99BCE5;
				}

				.name {
					text-transform: uppercase;
					font-weight: 700;
					font-size: 24px;
					color:#FFFFFF;
					margin-top: 9px;
					margin-bottom: 12px;

					i{
						color: #59708F;
						margin-right: 10px;
					}
					i:nth-child(2n){
						margin-left: 10px;
					}
				}

				.info {
					margin-top:10px;
					font-size: 15px;
					color:#59708F;
				}
			}

			.btns {
				display: inline-flex;
				justify-content: space-around;
				color:#FFFFFF;
				font-family: Roboto;
				font-stretch: condensed;

				.rename, .add, .delete, .voltar, .clonar {
					display: flex;
					align-items: center;
					background-color:#59708F;
					padding: 9px 15px 10px;
					border: none;
					color: #FFF;
					font-size: 20px;
					border-radius: 5px;
					margin-right: 10px;
					font-family: Roboto;
					max-width: 50px;
					min-width: 50px;
					cursor: pointer;
					transition: 0.666s max-width ease;

					.text {
						display: inline-block;
						transform: scaleX(0);
						transition: 0.444s transform ease;
						transform-origin: left center;
						margin-left: 10px;
						padding-right: 5px;
					}
				}
				.rename:hover, .voltar:hover{
					background-color:#ffffff;
					color: #59708F;
					max-width: 200px;
					.text {
						transform: scaleX(1)
					}
				}
				.clonar:hover {
					background-color:#99BCE5;
					color: #ffffff;
					max-width: 200px;
					.text {
						transform: scaleX(1)
					}
				}
				.add:hover {
					background-color:#e2e41a;
					color: #59708F;
					max-width: 200px;
					.text {
						transform: scaleX(1)
					}
				}
				.delete:hover {
					background-color:#d9534f;
					color: #ffffff;
					max-width: 200px;
					.text {
						transform: scaleX(1)
					}
				}

				.send {
					display: flex;
					justify-content: center;
					background-color:#00659D;
					width: 100px;
					padding: 9px 0px 10px;
					border: none;
					color: #FFF;
					text-transform: uppercase;
					font-weight: 700;
					font-size: 19px;
					border-radius: 5px;
					margin-right: 10px;
					font-family: Roboto;
					max-width: unset;
					cursor: pointer;
				}
			}
		}
		.object-list {
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			cursor: move;

			.number {
				display: flex;
				color: #59708F;
				font-size: 20px;
				font-weight: 700;
				width: 5%;
				align-items: center;

				.ball {
					background-color: #59708F;
					border-radius:5px;
					width: 9px;
					height: 9px;
					margin-left: 5px;
				}
			}
			.box-object {
				display: grid;
				width:100%;
				align-items: center;
				grid-template-columns: 2fr 7fr 7fr 2fr;
				padding: 10px 20px;
				border-radius: 10px;
				background-color: #061529;
				color: #59708F;
				font-family: 'Roboto Condensed', 'Roboto', sans-serif;

				i {
					color: #59708F;
				}

				.name-object {
					color: #99BCE5;
				}

				.type {
					color: #FFFFFF;
				}

				.bts {
					display:flex;
					color:#FFFFFF;
					font-family: Roboto;
					font-stretch: condensed;

					.comment, .view, .delete {
						display: flex;
						align-items: center;
						padding: 8px;
						border: none;
						color: #FFF;
						font-size: 20px;
						border-radius: 5px;
						margin-right: 10px;
						font-family: Roboto;
						max-width: 50px;
						min-width: 50px;
						cursor: pointer;
						transition: 0.666s max-width ease;

						i {
							color: #FFF;
						}

						.txt {
							display: inline-block;
							transform: scaleX(0);
							transition: 0.444s transform ease;
							transform-origin: left center;
							margin-left: 10px;
							padding-right: 5px;
							color: #FFF;
							font-size: 16px;
						}
					}
					.comment:hover {
						max-width: 200px;
						color: #FFF;
						.txt {
							color: #FFF;
							transform: scaleX(1);
						}
					}
					.view:hover {
						max-width: 200px;
						i {
							color: #e2e41a;
						}
						.txt {
							color: #e2e41a;
							transform: scaleX(1);
						}
					}
					.delete:hover {
						max-width: 200px;
						i {
							color: #d9534f;
						}
						.txt {
							color: #d9534f;
							transform: scaleX(1);
						}
					}
				}
			}
		}

		form {
			width: 100%;
			background-color: #fff;
			padding: 15px;
			margin-top: 50px;
			.row {
				display: flex;
				margin: 0 auto;
				justify-content: space-between;
				margin-top: 35px;
				label {
					display: block;
					display: flex;
					justify-content: center;
					margin-bottom: 5px;
					color: #052354;
					font-weight: bold;

					span {
						text-transform: uppercase;
						margin-left: 10px;
					}
				}
			}
			.full {
				input {
					width: 634px;
				}
			}
		}
		.actions {
			margin-top: 40px;
			display: flex;
			justify-content: flex-end;
			button:first-child {
				margin-right: 10px;
				background-color: #fff;
				color: #000;
				border: 1px solid #06162B;
			}
			button:nth-child(2n) {
				background-color: #00659D;
				color: #fff;
				border: 1px solid #00659D;
			}
			button {
				border-radius: 5px;
				height: 47px;
				width: 136px;
				font-weight: bold;
			}
		}
	}
</style>
